var $cd5db160c0f55b1b$exports = {};
$cd5db160c0f55b1b$exports = {
    "(optional)": `(valinnainen)`,
    "(required)": `(pakollinen)`
};


export {$cd5db160c0f55b1b$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
